module.exports = __webpack_public_path__ + "c44cb5174313d16a8bed3fdc1a86fcc1.png";